import React from "react";
import ComingSoonPanel from "../components/ComingSoonPanel";

const LTVPage: React.FC = () => {
    return (
        <ComingSoonPanel
            title="LTV分析"
            description="顧客ごとの購入履歴からLTVを算出して表示する想定です。"
        />
    );
};

export default LTVPage;
